module.exports = __webpack_public_path__ + "app/data/fimFieldGroups.json";